export const URL = `https://19429ba06ff2.vps.myjino.ru/api`;
export const comandID = 'ivanova_project_work1'